var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.956 10.692 25.55 5.38a1.41 1.41 0 0 1 1.726 1.727L21.964 25.7c-.398 1.195-1.992 1.328-2.523.133l-3.72-8.767-8.765-3.719c-1.329-.664-1.196-2.258 0-2.656Z",
    fill: "#10A8BA"
  })));
};
export default SvgLocation;